import React from "react"

export const ParsingAnimationElement: React.FunctionComponent<
    IParsingAnimationElementProps
> = props => {
    return (
        <div className={`flex flex-col gap-[12px] ${props.className ?? ""}`}>
            {[72, 88, 64, 96, 80].map((width, index) => (
                <div
                    key={index}
                    className="h-[16px] rounded-[4px] bg-brand-warmLight animate-pulse"
                    style={{ width: `${width}%` }}
                />
            ))}
        </div>
    )
}

interface IParsingAnimationElementProps {
    className?: string
}
